import React from 'react';
import { Fade, Zoom } from 'react-reveal';
import PinkImg from '../Image/HeroPinkImg';
import { Link } from 'gatsby';
import heroData from '../../mock/hero.json';

const Hero = () => (
  <div className="hero-wrapper">
    <div className="hero-message-wrapper">
      <Fade duration={200} distance="500px" delay={100}>
        <PinkImg />
      </Fade>

      <Fade bottom duration={100} distance="30px">
        <h3 className="hero-overtitle">{heroData.overTitle}</h3>
      </Fade>
      <Fade bottom duration={200} distance="300px">
        <h2 className="hero-title">{heroData.title}</h2>
        <h2 className="hero-title-name text-color-main">{heroData.afterTitle}</h2>
        <h2 className=" text-color-main">{heroData.afterTitle2}</h2>
      </Fade>
    </div>
    <Zoom duration={500} delay={10}>
      <div className="hero-cta">
        <div className="btn-wrapper btn d-flex flex-column">
          <h2 className="text-white text-center">HOME SERVICE</h2>
          <Link to={heroData.link_to_ButtonTwo}>
            <span className="cta-btn cta-btn--hero">{heroData.buttonTwo}</span>
          </Link>
        </div>
        <div className="btn-wrapper btn d-flex flex-column with-two-lines">
          <h2 className="text-white text-center d-flex flex-column">STUDIO SERVICE <span className="text-color-main">& Chinese Tea Ceremony</span></h2>
          <Link to={heroData.link_to_ButtonOne}>
            <span className="cta-btn cta-btn--hero">{heroData.buttonOne}</span>
          </Link>
        </div>
        <div className="btn-wrapper btn d-flex flex-column with-two-lines">
          <h2 className="text-white text-center d-flex flex-column">BABYSITTER SERVICE</h2>
          <Link to={heroData.link_to_ButtonThree}>
            <span className="cta-btn cta-btn--hero">{heroData.buttonThree}</span>
          </Link>
        </div>
      </div>
    </Zoom>
  </div>
);

export default Hero;
